import { DiTokens } from "../../services/diTokens";
import { getRandInt } from "../../utilities/index";
import { PersonStore } from "../../store/modules/person";
import { NotifyData } from "../../data/notifyData";
import { Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import IPersonService from "../../services/person/IPersonService";
import { container } from "@/inversify.config";

export class NotificationsVue extends Vue {
  /**Стор настроек */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  get personService(): IPersonService {
    return container.get<IPersonService>(DiTokens.PersonService);
  }

  get notifications() {
    return this.personStore.notifyData;
  }

  get notifyLoading(): boolean {
    return this.personStore.loading;
  }

  dialog: boolean = false;

  notifyDetail: NotifyData = new NotifyData();

  loading: boolean = true;

  deleteLoading: boolean = false;

  getRandWidth() {
    return getRandInt(100, 200);
  }

  async showDetails(notify: NotifyData) {
    try {
      this.loading = true;

      this.notifyDetail = notify;
      const res = await this.personService.fetchNotifyDetails(notify);

      if (this.notifyDetail) {
        this.notifyDetail.State = 2;
        this.notifyDetail.Text = res.Text;
      }

      this.dialog = true;

      this.personStore.setNewNotifyCount();
    } catch (e) {
      this.dialog = false;
    }
    this.loading = false;
  }

  async deleteNotify(notify: NotifyData, e: any) {
    e.stopPropagation();
    this.deleteLoading = true;
    this.personStore.setNotifyData(
      await this.personService.deleteNotify(notify.Id)
    );

    this.personStore.setNewNotifyCount();
    this.deleteLoading = false;
  }
}
